

export class IResetRecoverModel {
  
  userId?:string;
  code:string;
  nuovaPassword:string;

  }



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/models/account/ilogin-reset-recover.model.ts